// export const API_URL = 'http://localhost:3009';
// export const PENSION_API_URL = 'https://localhost:3005';
// export const UPLOADS_API_URL = 'http://localhost:3001';
 export const API_URL = 'https://srv547457.hstgr.cloud:3009';
 export const UPLOADS_API_URL = 'https://srv547457.hstgr.cloud:3020';
 export const PENSION_API_URL = 'https://srv547457.hstgr.cloud:3005';